<template>
  <div class="hb-date-picker">
    <label v-if="!hideTitle" class="header date" for="date">CHECK AVAILABLE DELIVERY DATES</label>
    <v-date-picker @input="updateDate" is-required :attributes="attrs" v-bind="dateConfig" v-model="date">
      <template v-slot="{ inputValue, inputEvents }">
        <div class="input-wrapper">
          <span class="iconc-calendar"></span>
          <input
            autocomplete="off"
            class="bg-white border px-2 py-1 rounded"
            :value="inputValue"
            placeholder="Select a date"
            v-on="inputEvents"
            name="attributes[delivery-date]"
          />
        </div>
      </template>
    </v-date-picker>
  </div>
</template>

<script>
import moment from 'moment';
import { TYPE_SET_DELIVERY_DATE } from '../../store/mutations';
export default {
  name: "hb-datepicker",
  props: {
    availability: Object,
    hideTitle: Boolean
  },
  data() {
    //move postcode to json later
    return {
      attrs:[
        {
          highlight: '#cb555b'
        }
      ]
    };
  },
  methods: {
    convertToDisabledDates(availableDates) {
      let unavailableDays = [];
      for (let day of availableDates) {
        let realDay = parseInt(day) + 1;
        if(realDay == 8)
          unavailableDays.push(1)
        else
          unavailableDays.push(realDay);
      }

      return unavailableDays;
    },
    updateDate(val){
      this.$emit('input',val)
      this.$emit('change');
      this.removeError();
    },
    removeError(){
      document.querySelector('.hb-date-picker .input-wrapper').classList.remove('error--text');
    },
    computeAdvanceDate(){
      const advanceNotice = this.product.locations.nationwide_advance_notice;
      let result = []
      const byDay = advanceNotice.by_day;
      const byDate = advanceNotice.by_date;
      const today = moment().isoWeekday();

      if(byDay !== null){
        for(let i = 1; i < 8; i++){
          let targetDate = i < today? moment().add(1, 'weeks').isoWeekday(i) : moment().isoWeekday(i);

          if(targetDate.clone().subtract(byDay[i].days, 'days').format('x') <= moment().format('x')){
            result.push(targetDate.toDate());
          }
            
        }
      }
      else if(byDate.length){
        result = byDate;
      }
      // console.log(result, byDay, byDate, today)
      return result;
    }
  },
  computed: {
    dateConfig() {
      const config = {
        "disabled-dates": [],
        "available-dates": []
      };
      let minDate = moment().utcOffset("+0800").add(-1, 'days').toDate();

      //check cutoff time
      const deliveryArea = this.$store.state.deliveryArea;
      const deliveryPlan = this.$store.state.delivery.delivery_plan;
      let cutoffTime = this.product.cutoff_time?.[deliveryArea]?.[deliveryPlan];
      const now = new Date();
      if(cutoffTime){
        cutoffTime = moment(cutoffTime, 'HHmm').utcOffset("+0800").toDate()
        
        if(moment().utcOffset('+0800').valueOf() >= cutoffTime.getTime()){
          const tomorrow = moment().utcOffset('+0800').toDate();
          minDate = tomorrow;
        }
      }

      //disable all if no limit
      if(!this.product?.available_dates?.[this.area]?.available_date_range?.start_date || 
        !this.product?.available_dates?.[this.area]?.available_date_range?.end_date){
          config['disabled-dates'] = {start: null, end: null};
          return config
        }

      //check available days
      if (this.product?.available_dates?.['same_day']?.available_dates) {
        this.product.available_dates['same_day'].available_dates.forEach(date => {
          if(moment().utcOffset('+0800').isBefore(moment(date, 'YYYYMMDD')))
            config["available-dates"].push(moment(date, 'YYYYMMDD').toDate())
        })
      }
        
      
      //check available date range
      if (
        this.product?.available_dates?.[this.area]?.available_date_range?.start_date || 
        this.product?.available_dates?.[this.area]?.available_date_range?.end_date
        ) {
          const startDate = moment(this.product?.available_dates?.[this.area].available_date_range.start_date,"YYYYMMDD").subtract(1, 'days').toDate()
          const endDate = moment(this.product?.available_dates?.[this.area].available_date_range.end_date,"YYYYMMDD").add(1,'days').toDate()
          config["disabled-dates"].push({start: null, end: startDate.getTime() < (new Date()).getTime()? minDate : startDate})
          config["disabled-dates"].push({start: endDate.getTime() < (new Date()).getTime()? null : endDate, end: null})
      }

      //check disabled dates
      if(this.product?.available_dates?.[this.area]?.disabled_dates?.length){
        this.product.available_dates[this.area].disabled_dates.forEach(date => {
          config["disabled-dates"].push( moment(date, 'YYYYMMDD').toDate())
        });
      }

      // check disabled days
      if(this.product?.available_dates?.[this.area]?.disabled_days){
        config["disabled-dates"].push(
          {
            weekdays: this.convertToDisabledDates(this.product?.available_dates?.[this.area]?.disabled_days),
          }
        )
      }

      //check advance date
      if(this.area === 'nationwide'){
        config["disabled-dates"] = [...config["disabled-dates"], ...this.computeAdvanceDate()];
      }

      return config;
    },
    date:{
      get(){
        return this.$store.state.delivery.delivery_date;
      },
      set(value){
        this.$store.commit(TYPE_SET_DELIVERY_DATE, value);
      }
    },
    product(){
      return this.$store.state.productDetails
    },
    area(){
      return this.$store.state.deliveryArea;
    },
    cutoffTime(){
      return this.product.cutoff_time;
    }

  },
};
</script>

<style>
</style>